import React from "react";
import { FiUser } from "react-icons/fi";

const Promo = () => {
  return (
    <div className="my-20 py-20 md:px-20 px-8 bg-dry">
      <div
        className="lg:grid lg:grid-cols-2 lg:gap-10 items-center"
        data-aos="zoom-in"
      >
        <div className="flex lg:gap-19 gap-6 flex-col">
          <h1 className="xl:text-3xl text-xl capitalize font-sans font-medium xl:leading-relaxed ">
            Download Your Movies Watch Offline. <br /> Enjoy on Your Mobile
          </h1>
          <p className="text-gray-500 text-sm xl:text-base leading-6 xl:leading-8">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur
            est maiores, delectus quaerat quo facilis nisi quod. Laboriosam
            quidem nihil animi molestiae hic consequatur doloribus at illum
            fugit, veritatis quae.
          </p>
          <div className="flex gap-4 md:text-lg text-sm">
            <div className="flex-colo bg-black text-subMain px-6 py-3 rounded font-bold">
              HD 4K
            </div>

            <div className="flex-rows gap-4 bg-black text-subMain px-6 py-3 rounded font-bold">
              <FiUser /> 2k
            </div>
          </div>
        </div>
        <div>
          <img
            src="/images/mobile phones.png"
            alt="Mobile app"
            className="w-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default Promo;
